import React, { Component } from 'react';
import { Container, Menu, Segment, Loader } from 'semantic-ui-react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import GeocodeSearch from './GeocodeSearch';
import Forecast from './Forecast';
import location from '../location';
import '../styles/ForecastContainer.css';

class ForecastContainerClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: 'current',
      current: null,
      next: null,
      extended: null
    };
  }

  componentDidMount() {
    const searchParams = this.props.searchParams;
    const lat = searchParams.get('lat');
    const lng = searchParams.get('lng');
    
    Promise.resolve((lat && lng) ? {lat, lng} : location.getLocation())
    .catch(e => {
      console.log('Geolocation unavailable, using default location'); // eslint-disable-line no-console
      return {lat: 37.774546, lng: -122.433523};
    })
    .then(position => {
      console.log(position); // eslint-disable-line no-console

      this.setState({
        current: null,
        next: null,
        extended: null
      });

      Promise.all([
        this.props.nearestNeighbor(position.lat, position.lng, 1),
        this.props.nearestNeighbor(position.lat, position.lng, 2),
        this.props.nearestNeighbor(position.lat, position.lng, 3)
      ]).then(response => {
        console.log(response); // eslint-disable-line no-console
        this.setState({
          current: response[0],
          next: response[1],
          extended: response[2]
        });
      }).catch(e => {
        console.log('Error loading forecast data:', e); // eslint-disable-line no-console
      });
    });
  }

  componentDidUpdate(prevProps) {
    const searchParams = this.props.searchParams;
    const prevSearchParams = prevProps.searchParams;
    
    if ((this.props.nearestNeighbor !== prevProps.nearestNeighbor) || 
      (searchParams.get('lat') !== prevSearchParams.get('lat'))) {
      this.componentDidMount();
    }
  }

  handlePositionChanged = position => {
    const pathname = this.props.location.pathname;
    this.props.navigate(`${pathname}?lat=${position.lat}&lng=${position.lng}`);
  }

  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name });
  }

  render() {
    const { activeItem } = this.state;
    const forecast = this.state[activeItem] ? <Forecast response={this.state[activeItem]}/> : <Loader active inline='centered' size='huge'>Loading</Loader>;

    return (
      <Container text className='forecast-container'>
        <GeocodeSearch onPositionChanged={this.handlePositionChanged} />
        <Menu pointing secondary fluid widths={3} style={{borderRadius: 0}}>
          <Menu.Item name='current' active={activeItem === 'current'} onClick={this.handleItemClick} />
          <Menu.Item name='next' active={activeItem === 'next'} onClick={this.handleItemClick} />
          <Menu.Item name='extended' active={activeItem === 'extended'} onClick={this.handleItemClick} />
        </Menu>

        <Segment basic>
          {forecast}
        </Segment>
      </Container>
    );
  }
}

// HOC to inject router hooks into class component
function ForecastContainer(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  return (
    <ForecastContainerClass 
      {...props} 
      navigate={navigate} 
      location={location} 
      searchParams={searchParams}
    />
  );
}

export default ForecastContainer;
